export default class TrackingHelper{

    static initTracking() {
      let script = document.createElement('script');
      script.setAttribute('type', 'text/javascript');
      script.innerHTML = `(function (w, d, s, l, i) {
                w[l] = w[l] || []; w[l].push({
                    'gtm.start':
                        new Date().getTime(), event: 'gtm.js'
                }); var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-KQ2SV32');`;
      document.body.appendChild(script);
    }

    static virtualPageview(element) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({
        event: 'virtual_page_view',
        element_name: element.toLowerCase(),
      }, this.getDefaultData()));
    }

    static initialPageview() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(this.getDefaultData());
    }

    static clickTracking(type, name) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'click',
        'element_type': type.toLowerCase(),
        'element_name': name.toLowerCase()
      });
    }

    static downloadTracking(name, url) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'file_download',
        'element_type': 'file',
        'element_name': name.toLowerCase(),
        'link_url': url
      });
    }

    static formTracking(type, additionalParams) {
      let trackData = {
        'event': type === 'submit' ? 'form_submit': 'form_start',
        'element_type': 'form',
        'form_name': 'request quotation'
      }
      if(additionalParams) {
        trackData = Object.assign(trackData, additionalParams);
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(trackData);
    }

    static getDefaultData() {
      return {
        'business_unit':'flat glass',
        'market': 'retail and gastronomy',
        'platform_name': 'coldroom configurator',
        'sbf': 'food display',
        'schott_application': 'commercial refrigeration',
      }
    }
}

